import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";
import {LoadingDialog} from "../../../../components/DialogLoading";

export enum RESET_PASSWORD_MODAL_CONTENT {
  LOADING = 'loading',
  MESSAGE = 'message',
}

export const ResetPasswordModalContent = ({
  message,
  messageType,
  onClickOkButton,
}) => ({
  loading: (
    <LoadingDialog label="提交申請中..." />
  ),
  message: (
    <TwoButtonDialog
      type={messageType}
      title={message}
      leftLabel="OK"
      leftOnClick={onClickOkButton}
      leftIconName="fa-check"
    />
  )
})